import { render, staticRenderFns } from "./applicant_table.vue?vue&type=template&id=20617be8&scoped=true"
import script from "./applicant_table.vue?vue&type=script&lang=ts"
export * from "./applicant_table.vue?vue&type=script&lang=ts"
import style0 from "./applicant_table.vue?vue&type=style&index=0&id=20617be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20617be8",
  null
  
)

export default component.exports